export default __webpack_public_path__ + "static/reading-classes-41ca5747ca7905fd1eff524c2e8a2a03.png";